import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetOrganisationHierarchyInfoModalDocument = gql`
  query GetOrganisationHierarchyInfoModal($organisationId: Int!) {
    organisation(id: $organisationId) {
      id
      name
      legalEntity
      departmentCode
      isVerified
      ... on Purchaser {
        paperlessInvoicingIdentityEmail
        invoiceWorkflow {
          id
          name
        }
        requisitionWorkflow {
          id
          name
        }
        creditNoteWorkflow {
          id
          name
        }
        featureFlags {
          apHubType
        }
        defaultAccount {
          id
          codedName
        }
      }
    }
  }
` as unknown as DocumentNode<
  Types.GetOrganisationHierarchyInfoModalQuery,
  Types.GetOrganisationHierarchyInfoModalQueryVariables
>
